import { createSlice } from "@reduxjs/toolkit"
import moment from "moment"
import { DEPARTMENT_FILTER, DETAILS_ACTIONS_FILTER, SORT_ORDER } from "../../utilities/constants"

const DetailsActionSlice = createSlice({
  name: "DETAILS_ACTIONS",
  initialState: {
    filters: {
      [DETAILS_ACTIONS_FILTER.SORT_ORDER]: SORT_ORDER.HIGHEST,
      [DETAILS_ACTIONS_FILTER.DEPARTMENT]: DEPARTMENT_FILTER.ALL,
    },
    searchText: "",
    currentHistoricalDate: null,
  },
  reducers: {
    // Search Actions
    setSearchText: (state, action) => {
      const _searchText = action?.payload
      state.searchText = typeof _searchText === "string" ? _searchText.trim() : ""
    },

    // Filter Actions
    // action.payload to be like { filterParam: string, filterValue: string | string[] }
    setFilters: (state, action) => {
      const filterKey = action?.payload.filterParam
      const filterValue = action?.payload.filterValue
      const filters = { ...state.filters }
      if (Object.keys(state.filters).includes(filterKey)) {
        filters[filterKey] = filterValue
      }
      state.filters = { ...filters }
    },

    // Updated Historical Date can be set here
    // action.payload to be like { currentDate: null | ISO Date string }
    setCurrentHistoricalDate: (state, action) => {
      const { date } = action.payload
      if (date && moment(date).isValid()) {
        state.currentHistoricalDate = date
      } else {
        state.currentHistoricalDate = null
      }
    },
  },
})

export const DetailsActionsActions = DetailsActionSlice.actions
export default DetailsActionSlice
